export default "__VITE_ASSET__BUa7WGuV__"